import { Component, Input } from '@angular/core';
import { CustomerData } from '../../customer.model';

@Component({
    selector: 'ifb-customer-other-info-widget',
    templateUrl: './customer-other-info-widget.component.html',
    styleUrls: ['./customer-other-info-widget.component.scss'],
    standalone: false
})
export class CustomerOtherInfoWidgetComponent {
  @Input()
  data: CustomerData;

  @Input()
  edit: boolean;
}
